<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @del="del" @imp='imp' ref="SetBtn"></buttonlist>
        <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo" value="0">
            <el-tab-pane :label="$t('getapi[8277]')" name="0" id="xpane-0">
                <wTable
                        :data="dataSet"
                        :loading="loading"
                        queryData="V_ENG_WI_Show"
                        :filter_language="['Order_Status']"
                        :header="tableHeader"
                        :option="tableOption"
                        @lct="lct"
                        @handleSelectionChange="handleSelectionChange"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight - reduceTableHeight"
                        header-row-class-name="headerclass"
                        @selection-change="handleSelectionChange"
                        
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code"
                                     :label="$t('getapi[112]')" fixed="left"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version"
                                     :label="$t('getapi[149]')" fixed="left"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_routing"
                                     :label="$t('getapi[6249]')" fixed="left"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code"
                                     :label="$t('getapi[876]')" fixed="left"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Status"
                                     :label="$t('getapi[6250]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Order_Plan_Date"
                                     :label="$t('getapi[6251]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="WI_routing"
                                    :label="$t('getapi[6252]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="QtyText"
                                     :label="$t('getapi[6253]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="MODIFY_PERSON"
                                    :label="$t('getapi[6254]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="MODIFY_TIME"
                                    :label="$t('getapi[6255]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_name"
                                    :label="$t('getapi[116]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_3_Text"
                                     :label="$t('getapi[6256]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_3_UNAME"
                                     :label="$t('getapi[6257]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_3_DATE"
                                     :label="$t('getapi[6258]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_11_Text"
                                     :label="$t('getapi[6259]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_11_UNAME"
                                     :label="$t('getapi[6257]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_11_DATE"
                                     :label="$t('getapi[6258]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_22_Text"
                                     :label="$t('getapi[6260]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_22_UNAME"
                                     :label="$t('getapi[6257]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_22_DATE"
                                     :label="$t('getapi[6258]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_23_Text"
                                     :label="$t('getapi[6261]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_23_UNAME"
                                     :label="$t('getapi[6257]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_23_DATE"
                                     :label="$t('getapi[6258]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_24_Text"
                                     :label="$t('getapi[6262]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_24_UNAME"
                                     :label="$t('getapi[6257]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_24_DATE"
                                     :label="$t('getapi[6258]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_0_Text"
                                     :label="$t('getapi[6263]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_0_UNAME"
                                     :label="$t('getapi[6257]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DT_0_DATE"
                                     :label="$t('getapi[6258]')"></el-table-column>
                </el-table>-->
                <el-row class="page">
                    <el-col :span="18">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[100, 200, 300, 400]"
                                :page-size="pageSize"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                        ></el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{
                            DbTbNames }}
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6266]')" name="1" id="xpane-1">
                <el-table
                        :data="dataSet1"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        @selection-change="handleSelectionChange"
                        style="width: 100%; margin-top:0px"
                        ref="singleTable1"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="WI_NAME"
                                     label="WI&II"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="WI_N2"
                                     :label="$t('getapi[6253]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="WI_N1"
                                     :label="$t('getapi[6264]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="WI_TIME"
                                     :label="$t('getapi[6265]')"></el-table-column>
                    </el-table>
            </el-tab-pane>
        </el-tabs>
        <serce :isVisible="isVisible" queryData="V_ENG_WI_Show" ref="ser"
               @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6531]')" queryData="V_ENG_WI_Show" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
      
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
		name:'wi&iidetail',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 全部
                dataSet1: [], // 生成
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                DbTbNames1: '',
                pageIndex: 0, // 当前页
                pageSize: this.$http.getPageSize('wi&iidetail'), // 当前页数据量
                pageIndex1: 1, // 当前页
                pageSize1: 100, // 当前页数据量
                SelectIndex: 0, //当前页面
                total: 0, // 全部数据总量
                total1: 0, // 生成数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                selectData: [], // 多选数组
                scrollTop:0,
                scrollTop1:0,
            };
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })

        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('V_ENG_WI_Show', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6531]"),this.$t("getapi[18]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 356, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 356, 1) == 2) {
                    if (that.$limits.authority('plv3', 356,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 356,1) == 1) {
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('import,search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 356, 1) == 2) {
                        //删除级
                        if(that.selectData.length > 0 ){
                            that.$refs.SetBtn.SetButtonEnable('import,search,refresh,export,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('import,search,refresh,export');
                        }
                    }
                }
            },
            handleSizeChange(val) {
                let that = this;
                that.pageSize = val;
                this.$http.savePageSize('wi&iidetail',val)
                that.getView();
                that.authority();
            },
            handleCurrentChange(val) {
                let that = this;
                that.pageIndex = val;
                that.getView();
                that.authority();
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'V_ENG_WI_Show');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                if(that.SelectIndex == 0){
                    that.loading = true;
                    let datac = [];
                    for (let i = 0; i < that.queryData.length; i++) {
                        datac.push({
                            query_Condition: that.queryData[i].query_Condition,
                            query_field_type: that.queryData[i].Query_Field_Type,
                            query_field_name: that.queryData[i].Query_Field_Name,
                            query_sort: that.queryData[i].query_sort,
                            row_sign: that.queryData[i].row_sign
                        });
                    }
                    let token = JSON.parse(that.userData).token;
                    let data = {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        SelectIndex: that.SelectIndex,
                        Param: datac
                    };
                    that.$http.urlpost('/Eng/WIView/GetWIShowView', data, function (res) {
                        if (res.Success == 1) {
                            that.dataSet = res.DataContent
                            that.total = res.Totals
                            that.loading = false;
                            that.DbTbNames = res.DbTbNames;
                            that.authority();
                        }
                        that.$nextTick(function(){
                            that.$processdata.initForm(that.SelectIndex)
                        });
                    });
                } else {
                    that.$http.urlpost('/Eng/WIView/GetWIShowTotalView', '', function (res) {
                        if (res.Success == 1) {
                            that.dataSet1 = res.DataContent
                            that.loading = false;
                            that.DbTbNames1 = res.DbTbNames;
                            that.authority();
                        }
                        that.$nextTick(function(){
                            that.$processdata.initForm(that.SelectIndex)
                        });
                    });
                }
            },
            //ecn一览
            lct(val) {
                let that = this
                let item = {
                    //ecn一览
                    label:  this.$t('getapi[6125]'),
                    name: 'ecnlist',
                    path: '/ecnlist',
                    url: '/ecnlist',
                    icon: 'video-play'
                };
                that.$store.commit('setSharedParams', {
                    part_code: val.row.part_code
                });
                this.$router.push({ path: '/ecnlist'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Eng/WIView/GetWIShowViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
                /*let that = this;
                let datac = [];
                let fname = that.$t('getapi[8277]')
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "V_ENG_WI_Show",
                    fromname: fname,
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            selectInfo(tab) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
            },
            add() {
                let that = this;
                that.isShowEdit = true;
                that.$refs.order.clearInput(that.isShowEdit, '');
            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        let lan = that.$processdata.getLang()
                        for(let i = 0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                Order_No: that.selectData[i].Order_No,
                                MODIFY_TIME: that.selectData[i].MODIFY_TIME,
                                LangType: lan
                            }]
                        }
                        let parm = arr
                        that.$http.urlpost('/Eng/WIView/DeleteWIShow', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            imp(){
                let item = {
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/30',
                    url: '/exp/30',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/exp/30' });
                this.$store.commit('selectMenu', item);
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .blue {
        background: #9dd9ff;
    }
</style>
